import { render, staticRenderFns } from "./exercises.vue?vue&type=template&id=1e195f57&scoped=true&"
import script from "./exercises.vue?vue&type=script&lang=js&"
export * from "./exercises.vue?vue&type=script&lang=js&"
import style0 from "./exercises.vue?vue&type=style&index=0&id=1e195f57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e195f57",
  null
  
)

export default component.exports